let total_price = 0;
let reg_price = 0;
let compareTotal = 0;

$(document).ready(function () {
    // Handle click event for Add to Bundle
    $(document).on('click', '.add_bundle', function () {
        // Get product details
        let el = $(this);
        bundlePrice(el, 1);
    });

    // Handle click event for Remove from Bundle
    $(document).on('click', '.bundle-remove', function () {
        // Get product price
        let el = $(this);
        if (!$("#terms").is(":checked")) {
            alert("Please agree to the terms and conditions before continuing.");
            return false; // stop further execution
        }
        bundlePrice(el, 0);
    });

    $(document).on('click', '#bundle_subscription', function (e) {
        e.preventDefault();
        let id = parseInt($(this).val());
        if (!$("#terms").is(":checked")) {
            alert("Please agree to the terms and conditions before continuing.");
            return false; // stop further execution
        }
        addToCart(id);
    })

    $(document).on('click', '#bundle_onetime', function (e) {
        e.preventDefault();
        let id = parseInt($(this).val());
        addToCart(id);
    })
});

function addToCart(plan_id) {
    let items = [];
        
    // Iterate over all bundle items
    $('.bundle-item').each(function () {
        const variantId = $(this).data('id');
        const sellingPlanId = $(this).data('selling-plan');
        const plan = plan_id; // Check the plan type (1 or 0)
        // Add product to items array
        let item = { id: variantId, quantity: 1 };
        // Include selling plan ID for subscription products
        if (plan === 1 && sellingPlanId) {
            item.selling_plan = sellingPlanId;
        }
        items.push(item);       
    });

    

    if (items.length > 0) {
        $.ajax({
            url: '/cart/add.js',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ items: items }),
            success: function () {
                // alert('Items added to cart successfully!');
                window.location.href = '/checkout'; // Redirect to cart
            },
            error: function (error) {
                console.log('Error adding items to cart: ' + error.responseText);
            }
        });
    } else {
        alert('No items to add to the cart!');
    }
}

function bundlePrice(el, e) {

    const productId = $(el).data('id'); // Variant ID
    let productTitle = $(el).data('title') || '';
    productTitle = productTitle.slice(0, 20) + '...';

    const img = $(el).data('img');
    let productPrice = parseInt($(el).data('price'));
    let comparePrice = parseInt($(el).data('compare'));
    let discountPrice = parseInt($(el).data('discount'));
    let discount = $('#discount_amount').val();
    let tmplt = $('#bundle_template').val();
    const sellingPlanId = $(el).data('plan'); // Subscription plan ID (if applicable)
    let itemSize; 
    if (comparePrice == 0) {
        comparePrice = productPrice;
    }else{
        comparePrice = comparePrice;
    }

    var cart_count = $('.bundle_count').data('count');


    // Update total bundle price
    if(e == 1) {
        total_price += discountPrice;
        reg_price += productPrice;
        compareTotal += comparePrice;
        // Add the product to the bundle section
        const bundleProductHTML = `
            <div class="bundle-item" data-id="${productId}" data-selling-plan="${sellingPlanId || ''}" data-plan="1">
                <input type="hidden" name="id[]" value="${productId}">
                <input type="hidden" name="selling_plan[]" value="${sellingPlanId || ''}">
                <div class="bundle-item-wrap">
                    <div class="bundle-image">
                        <span class="bundle-remove"  data-id="${productId}" data-discount="${discountPrice}" data-title="${productTitle}"  data-price="${productPrice}" data-compare="${comparePrice}">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50"> <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path></svg>
                        </span>
                        <img src="${img}" class="bundle-img">
                    </div>
                    <div class="bundle-item-content">
                        <h3 class="bundle-item-heading">${productTitle}</h3>
                        <p class="bundle-item-price">${currency + productPrice * 0.01}</p>
                    </div>
                </div>
            </div>
        `;

       
        $('.empty-text').hide();
        $('.bundle-items').append(bundleProductHTML);
        itemSize = $('.bundle-item').length; 

        itemSize = cart_count + itemSize
        $('.bundle_count').text(itemSize);
        
        // $(el).parent().parent().addClass('disabled');

        if (compareTotal > total_price) {
            $('.subs_compare, .onetime_compare').text(currency + (compareTotal * 0.01).toFixed(2));
        }

        // console.log('compareTotal dis ' + (compareTotal * discount * 0.01).toFixed(2))
        console.log('itemSize ' + itemSize)
        // $('.onetime_compare').text(currency + (compareTotal * discount * 0.01).toFixed(2))
        if(tmplt == 'bundle') {
            if(itemSize >= 3) {
                $('.onetime_compare, .subs_compare').show();
                $('#onetime_total').text(currency + (compareTotal * discount * 0.01).toFixed(2));
            }else{
                $('.onetime_compare, .subs_compare').hide();
                $('#onetime_total').text(currency + (compareTotal * 0.01).toFixed(2));
            }
        }else{
            // if(itemSize < 33) {
            //     $('.onetime_compare, .subs_compare').show();
            //     $('#onetime_total').text(currency + (compareTotal * 0.75 * 0.01).toFixed(2));
           // }else 
            if(itemSize >= 3) {
                $('.onetime_compare, .subs_compare').show();
                $('#onetime_total').text(currency + (compareTotal * discount * 0.01).toFixed(2));
            }else{
                $('.onetime_compare, .subs_compare').hide();
                $('#onetime_total').text(currency + (compareTotal * 0.01).toFixed(2));
            }
        }
        
    }else{
        // Update total bundle price
        total_price -= discountPrice;
        compareTotal -= comparePrice;
        reg_price -= productPrice;
        // Remove the product from the bundle section
        $(el).parent().parent().parent().remove();
        itemSize = $('.bundle-item').length; 
        
        itemSize = cart_count + itemSize
        $('.bundle_count').text(itemSize);
        // $('#onetime_total, .subs_compare').text(currency + (compareTotal * 0.01).toFixed(2)); 

        $('.subs_compare, .onetime_compare').text(currency + (compareTotal * 0.01).toFixed(2));
        if(tmplt == 'bundle') {
            if(itemSize >= 3) {
                $('.onetime_compare, .subs_compare').show();
                $('#onetime_total').text(currency + (compareTotal * discount * 0.01).toFixed(2));
            }else{
                $('.onetime_compare, .subs_compare').hide();
                $('#onetime_total').text(currency + (compareTotal * 0.01).toFixed(2));
            }
        }else{
            if(itemSize < 3) {
                $('.onetime_compare, .subs_compare').show();
                $('#onetime_total').text(currency + (compareTotal * 0.75 * 0.01).toFixed(2));
            }else if(itemSize >=3) {
                $('.onetime_compare, .subs_compare').show();
                $('#onetime_total').text(currency + (compareTotal * discount * 0.01).toFixed(2));

            }else{
                $('.onetime_compare, .subs_compare').hide();
                $('#onetime_total').text(currency + (compareTotal * 0.01).toFixed(2));
            }
        }
    }

    // Update the total price in the summary
    // total_price = currency + (total_price * 0.01).toFixed(2);
    if(tmplt == 'bundle') {
        if(itemSize >= 3) {
            let final_price = (total_price * 0.01).toFixed(2);
            final_price = (final_price * discount).toFixed(2); 
            let updated_price = Math.floor(final_price) + (Math.round((final_price % 1) * 100) + 1) / 100;
            // Convert to 2 decimal places for display
            updated_price = updated_price.toFixed(2);
            $('#subs_total').text(currency + updated_price);  
        }else{
            $('#subs_total').text(currency + (total_price * 0.01).toFixed(2));
        }
    }else{
        if(itemSize < 3) {
            let final_price = (total_price * 0.01).toFixed(2);
            final_price = (final_price * 0.75).toFixed(2); 
            let updated_price = Math.floor(final_price) + (Math.round((final_price % 1) * 100) + 1) / 100;
            // Convert to 2 decimal places for display
            updated_price = updated_price.toFixed(2);
            $('#subs_total').text(currency + updated_price);  
        }else if(itemSize >= 3) {
            let final_price = (total_price * 0.01).toFixed(2);
            final_price = (final_price * discount).toFixed(2); 
            let updated_price = Math.floor(final_price) + (Math.round((final_price % 1) * 100) + 1) / 100;
            // Convert to 2 decimal places for display
            updated_price = updated_price.toFixed(2);
            $('#subs_total').text(currency + updated_price);  
        }else{
            $('#subs_total').text(currency + (total_price * 0.01).toFixed(2));
        }
    } 

    if(itemSize == 0) {
        $('#subs_total').text(currency + '0.00');
    }
}


// all work fine 